import { FormField, FormItem, FormMessage } from "@/components/ui/form";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue
} from "@cmp-src/primitives/Select";
import SelectUsersAsync from "@/components/users/SelectUsersAsync";
import { SaveReservationData } from "@/lib/utils-reserve";
import { useAuthenticated } from "@gettactic/hooks";
import { FieldErrors, UseFormReturn } from "react-hook-form";

type Props = {
  form: UseFormReturn<any>;
  errors: FieldErrors<SaveReservationData>;
  defaultValue?: { value: string };
  readonly?: boolean;
};
export default function ReserveFieldOrganizer({
  form,
  errors,
  defaultValue,
  readonly = false
}: Props) {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  const isTeamManager =
    !!authenticatedUser?.user?.permissions.includes(
      "schedule:others:managed:add"
    ) && !authenticatedUser?.user?.permissions.includes("schedule:others:add");

  return (
    <>
      <FormField
        control={form.control}
        name="organizer"
        render={({ field }) => (
          <FormItem>
            <SelectUsersAsync
              defaultValue={[defaultValue?.value ?? ""]}
              managed={isTeamManager}
              setInitial={(x) => {
                // Before we can set default values we need to do an async call to retrieve IDs.
                form.setValue("organizer", x[0], { shouldValidate: false });
              }}
              onChange={field.onChange}
              value={field.value}
              className="w-full rounded-md border-gray-300"
              classNamePrefix="react-select"
              placeholder={"Select the Organizer"}
              isMulti={false}
              readonly={readonly}
            />
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}

/**
 * <Controller
        key={JSON.stringify([defaultValue])}
        control={control}
        name="organizer"
        render={({ field: { onChange, value } }) => (
          <SelectUsersAsync
            managed={isTeamManager}
            setInitial={(x) => {
              // Before we can set default values we need to do an async call to retrieve IDs.
              setValue('organizer', x[0], { shouldValidate: false });
            }}
            onChange={onChange}
            value={value}
            className="w-full rounded-md border-gray-300"
            classNamePrefix="react-select"
            placeholder={`Select the Organizer`}
            isMulti={false}
            readonly={readonly}
          />
        )}
      />
 */
